import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stats: {},
  statsInitialized: false,
};

const reducers = {
  setStats(state, action) {
    state.stats = action.payload;
    state.statsInitialized = true;
  },
  reset(state) {
    state.stats = {};
    state.statsInitialized = false;
  },
};

export const slice = createSlice({
  name: "dashboardHome",
  initialState,
  reducers,
});

export const { reducer } = slice;
